import { useEffect, useState } from 'react';
import { useVehicleStore } from '@/store/useVehicleStore';

/**
 * Whether the tenant has an active vehicle — the trip menu and the tab "Fahrten" only appear
 * then (FAFD-68). False while loading or when the list cannot be loaded.
 */
export function useHasActiveVehicles(): boolean {
  const fetchActiveVehicles = useVehicleStore((s) => s.fetchActiveVehicles);
  const [hasVehicles, setHasVehicles] = useState(false);

  useEffect(() => {
    let alive = true;
    fetchActiveVehicles()
      .then((vehicles) => alive && setHasVehicles(vehicles.length > 0))
      .catch(() => alive && setHasVehicles(false));
    return () => {
      alive = false;
    };
  }, [fetchActiveVehicles]);

  return hasVehicles;
}
